export class BackendErrorResponseDto {
  status: number;
  error: string;
  message: string;
}
